export function ReportsPage() {
  return (
    <div className="space-y-2">
      <h1 className="text-lg font-semibold">Rapporter</h1>
      <p className="text-sm text-gray-600">Modulen är aktiverad. Funktionalitet byggs i kommande task.</p>
    </div>
  );
}
